// extracted by mini-css-extract-plugin
module.exports = {"item":"check-list-item-module--item--31Upd","icon":"check-list-item-module--icon--2nxDW"};